import AvatarMarker from './AvatarMarker';

export default AvatarMarker;
